// Stub — full StageOutputViewer removed for Process-Industry-only cleanup.
// The original heavy viewer bundled Airport/Bridge/Highway/Master-plan viewers
// that only apply to Real-Estate + Infrastructure domains and referenced ~200
// named exports from deleted modules. A no-op replacement keeps existing
// imports (default + DownloadDPRButton) resolvable.
import React from "react";

export default function StageOutputViewer() {
  return null;
}

export function DownloadDPRButton() {
  return null;
}
